import React from "react";

interface DescriptionProps {
  description?: string;
  isError?: boolean;
}

const Description: React.FC<DescriptionProps> = ({ description, isError }) => {
  if (!description) return null;
  return (
    <div
      id="general-text"
      className="general-input-label"
      style={{
        display: "block",
        marginBottom: "6px",
      }}
    >
      <p
        dangerouslySetInnerHTML={{ __html: description ?? "" }}
        style={{
          fontSize: "12px",
          color: isError ? "#FDA29B" : undefined,
        }}
      />
    </div>
  );
};

export default Description;
